import buses from "./buses.component";
import busesUrls from "./buses.urls";
import BusesTransforms from "./buses.transforms";

const busesModule = angular
  .module("app.components.buses", [])
  .component("busesPage", buses)
  .service("BusesTransforms", BusesTransforms)
  .config(busesUrls);

export default busesModule;



// WEBPACK FOOTER //
// ./src/pages/buses/buses.module.js